import { useTheme } from '~/hooks/use-theme'

import type { TRefreshColors, TRefreshSizes } from '../types'

export const useRefreshVariants = () => {
  const theme = useTheme()

  const refreshSizeMapping: Record<TRefreshSizes, number> = {
    sm: theme.sizingSmall,
    md: theme.sizingMedium,
    lg: theme.sizingLarge,
  }

  const refreshColorMapping: Record<TRefreshColors, string> = {
    brand: theme.colorActionFillBrandPrimaryEnabled,
    neutral: theme.colorTextNeutralReadonly,
    black: theme.colorTextNeutralDefault,
    white: theme.colorTextNeutralInverse,
  }

  return {
    refreshSizeMapping,
    refreshColorMapping,
  }
}
